import React from "react";
import { StyledPageContainer } from "styles/components/PageContainer/index.styles";
import SEO from "components/CBSEO";
import SchemaComponent from "components/CBSchema";
import treatmentHubSeo from "./data/treatmentHubSeo.data.json";
import treatmentHubSchema from "./data/treatmentHubSchema.data.json";
import { constructSchemaData } from "utils/helpers/constructSchemaData";

// Dynamic Page Renderer
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";

// Components for componentMap
import DynamicHero from "components/DynamicHero";
import StartYourJourney from "pages/TherapyHub/components/startYourJourney";
import InsuranceSection from "components/InsuranceSection";
import GetStartedToday from "pages/TherapyHub/components/GetStartedToday";

// Content Data
import treatmentHubContent from "./data/treatmentHubContent.data.json";
import CardHubGrid from "components/CardHubGrid/CardHubGrid";

// Components that expect props to be spread directly
const SPREAD_PROPS_COMPONENTS = ["DynamicHero", "GetStartedToday", "TreatmentHubGrid", "CardHubGrid"];

// Component Map - mapping component type strings to React components
const componentMap = {
  "DynamicHero": DynamicHero,
  "StartYourJourney": StartYourJourney,
  "InsuranceSection": InsuranceSection,
  "GetStartedToday": GetStartedToday,
  "CardHubGrid": CardHubGrid,
};

const TreatmentHub = () => {
  const seoData = treatmentHubSeo;
  const schemaDataRaw = treatmentHubSchema;
  const schemaData = schemaDataRaw.url ? constructSchemaData(schemaDataRaw.url, schemaDataRaw.breadcrumbs) : [];

  const renderedComponents = useDynamicPageRenderer(treatmentHubContent, componentMap, SPREAD_PROPS_COMPONENTS);

  return (
    <StyledPageContainer id="treatment-hub-page-container">
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      <SchemaComponent schemas={schemaData} />

      {renderedComponents}
    </StyledPageContainer>
  );
};

export default TreatmentHub;
